import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantUnemploymentDetailsPage = {
  alert: {
    error: 'applicant-unemployment-details-page.form.alert.error',
  },
  footer: {
    root: 'applicant-unemployment-details-page.footer.root',
  },
  form: {
    grossAnnualIncomeInput:
      'applicant-unemployment-details-page.form.gross-annual-income-input',
    grossAnnualIncomeInputError:
      'applicant-unemployment-details-page.form.gross-annual-income-input-error',
    h1: 'applicant-unemployment-details-page.form.h1',
    h2: 'applicant-unemployment-details-page.form.h2',
    root: 'applicant-unemployment-details-page.form.root',
    submitButton: 'applicant-unemployment-details-page.form.submit-button',
  },
  header: {
    drawerButton: 'applicant-unemployment-details-page.header.drawer-button',
    previousStepButton:
      'applicant-unemployment-details-page.header.previous-step-button',
    root: 'applicant-unemployment-details-page.header.root',
  },
  progress: {
    root: 'applicant-unemployment-details-page.progress.root',
  },
} as const satisfies PageLocatorMap;
